import React, { useEffect } from 'react';
import OldUI from './new';
import NewUI from './new-ui';
import ScanUI from './scan-ui';
import { getIncomeSource } from '@/utils/vip';
import { getUrlParam } from '@/utils';
import classNames from 'classnames';
import Loading from '@/components/loading';
import { useAtom } from 'jotai';
import {
  isFromZhankuAtom,
  isInitAtom,
  isViewNewUiAtom,
  teamInfoAtom,
  userInfoAtom,
  ZhankuManagerInfoAtom,
} from '@/store';
import { initPage } from '@/utils/common';
import { SubscribeType, subscribeType } from '@/constants';

import styles from './index.module.css';

export interface TrackData {
  event_id: string;
  event_name?: string; // pc客户端埋点需要
  params: {
    [key: string]: any;
  };
}

const Subscription: React.FC = () => {
  const [isInit] = useAtom(isInitAtom);
  const [teamInfo] = useAtom(teamInfoAtom);
  const [isViewNewUi, setIsViewNewUi] = useAtom(isViewNewUiAtom);
  const [isFromZhanku] = useAtom(isFromZhankuAtom);
  const [zhankuManagerInfo] = useAtom(ZhankuManagerInfoAtom);
  const [userInfo] = useAtom(userInfoAtom);

  // Check if should show ScanUI
  const isOnlyShowScanUI = getUrlParam('isOnlyShowScanUI') === '1';

  useEffect(() => {
    // logo无限次订阅展示新版UI
    if (subscribeType === SubscribeType.LOGO_UNLIMITED) {
      setIsViewNewUi(true);
    }

    initPage();
  }, []);

  // pc订阅中，支持pc端登录操作
  const isPcLogin =
    getIncomeSource() !== 'MTXX-WEB' && getUrlParam('client_referer') === 'client_login';

  // 海洛客户，阻断提示
  if (isFromZhanku) {
    return (
      <div className={classNames(styles.main, styles.block)}>
        权益不足，请联系专属顾问：{zhankuManagerInfo?.manager} {zhankuManagerInfo?.phone}
      </div>
    );
  }

  // 企业版/来自服务市场用户，不允许线上购买
  if (teamInfo?.type === 2 || userInfo?.ban_purchase) {
    return (
      <div className={classNames(styles.main, styles.block)}>
        该版本不支持线上购买，如有需要请联系管理员
      </div>
    );
  }

  return (
    <>
      {isInit && !isPcLogin ? (
        isOnlyShowScanUI ? (
          <ScanUI />
        ) : isViewNewUi ? (
          <NewUI />
        ) : (
          <OldUI />
        )
      ) : (
        <Loading />
      )}
    </>
  );
};

export default Subscription;
